import type { SentryConfig } from '@core/analytics/interfaces/sentry';
import { NON_PRODUCTION_ENVIRONMENTS } from '../constants/sentry';

const isEnabled = (flag: unknown) => flag === true || flag === 'true';

const asText = (value: unknown) => typeof value === 'string' ? value : '';

export const getSentryConfig = (config: Record<string, unknown>): SentryConfig | null => {
  const { SENTRY_DSN, SENTRY_ENVIRONMENT, ENVIRONMENT, IS_LOCAL_HOST, SENTRY_SHADOW_POLICY } = config;

  if (typeof SENTRY_DSN !== 'string' || !SENTRY_DSN) {
    return null;
  }

  return {
    dsn: SENTRY_DSN,
    environment: asText(SENTRY_ENVIRONMENT),
    isNonProduction: NON_PRODUCTION_ENVIRONMENTS.has(asText(ENVIRONMENT)) || isEnabled(IS_LOCAL_HOST),
    isShadowPolicy: isEnabled(SENTRY_SHADOW_POLICY),
  };
};
